import React from "react";
import { Icon } from "@cadmakers-ui/icons";
import { Tooltip } from "@cadmakers-ui/core";
import { ISelectable } from "../../Models/ISelectable";
import styles from "../../Styles/WorkflowSelectorResultsBox.module.scss";

type Props = {
  selectedItems: ISelectable[];
  addButtonTitle?: string;
  removeButtonTitle?: string;
  onClickAdd: () => void;
  onClickRemove: (item: ISelectable) => void;
  disableAddButton?: boolean;
};

export const WorkflowSelectorResultsBox: React.FC<Props> = props => {
  return (
    <div className={styles.selectorContainer}>
      {props.selectedItems.map(i => {
        return (
          <div key={i.code} className={styles.itemRecord}>
            <div className={styles.itemRecordRemoveButtonContainer}>
              <Icon
                appName="GeneralLayout"
                assetName="GENERAL_L_X"
                className={styles.itemRecordRemoveButton}
                onClick={() => {
                  props.onClickRemove(i);
                }}
                title={props.removeButtonTitle}
              />
            </div>
            {i.name}
          </div>
        );
      })}
      <div className={props.disableAddButton ? styles.disabledAddItemButton : styles.addItemButton}>
        <Tooltip placement="top">
          <Tooltip.Trigger translate={{}}>
            <Icon
              appName="GeneralLayout"
              assetName="GENERAL_L_NewPart"
              onClick={props.disableAddButton ? () => {} : props.onClickAdd}
            />
          </Tooltip.Trigger>
          <Tooltip.Content translate={{}}>{props.addButtonTitle}</Tooltip.Content>
        </Tooltip>
      </div>
    </div>
  );
};
